<template>
  <div>
    <div class="row" v-if="activity.status != 'COMPLETED' && activity.status != 'REJECTED' && activity.status != 'CANCELLED'">
      <b-form-group
        id="input-trainer-position"
        :label="$t('training-view.trainerPosition')"
        label-for="trainer-position"
        label-align="left"
        class="col-2"
      >
        <b-select
        id="trainer-position"
        v-model="trainerToAdd.position" 
        :options="trainerPositions"
        @change="resetTrainerName">
        >
        </b-select>
      </b-form-group>
      <template v-if="trainerToAdd.position == 'TRAINER'">
        <b-form-group
          id="input-training-leader"
          :label="$t('training-view.addLeader')"
          label-for="input-leader"
          label-align="left"
          class="col-4"
        >
          <v-select
            v-if="availableTrainers != null"
            :options="availableTrainers"
            placeholder=""
            :clearable='false'
            v-model="trainerToAdd.member"
            :reduce="trainer => trainer.member"
            class="bg-white rounded"
            @search="getActiveLeaders"
          >
            <template #no-options="{ }">
              {{ $t("training-add.noTrainers") }}
            </template>
          </v-select>
        </b-form-group>
      </template>
      <template v-else>
        <b-form-group
          id="input-training-leader"
          :label="$t('training-view.addAssociateName')"
          label-for="input-leader"
          label-align="left"
          class="col-4"
        >
          <b-input
          id="search-input"
          v-model="trainerToAdd.associateName"
          type="search"
          :placeholder="$t('training-view.associateName')"
        ></b-input>
          
        </b-form-group>
      </template>
      <b-form-group
        id="input-trainer-type"
        :label="$t('training-view.trainerType')"
        label-for="trainer-type"
        label-align="left"
        class="col-2"
      >
        <b-select
        id="trainer-type"
        v-model="trainerToAdd.type" 
        :options="trainerTypes">
        >
        </b-select>
      </b-form-group>
      <b-form-group
        id="input-trainer-partTime"
        :label="$t('training-view.partTimeType')"
        label-for="trainer-partTime"
        label-align="left"
        class="col-2"
      >
        <b-select
        id="trainer-partTime"
        v-model="trainerToAdd.partTime" 
        :options="trainerPartTimeTypes">
        >
        </b-select>
      </b-form-group>
      <b-button variant="primary" class="esep-blue-bg col-lg-1 col-md-2 h-50 my-auto" @click="addTrainer()"
        :disabled='(trainerToAdd.position == "TRAINER" && !trainerToAdd.member) || (trainerToAdd.position == "ASSOCIATE" && !trainerToAdd.associateName) || !trainerToAdd.type || trainerToAdd.partTime == null'>
          {{ $t("common.add")}}</b-button>
      <hr />
    </div>
    <b-table 
      :items="activity.leaders"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      responsive
      show-empty
      thead-class="esep-blue-bg text-light"
    > 
      <template v-slot:cell(id)="row">
        {{ formatId(row.item) }}
      </template>

      <template v-slot:cell(fullName)="row">
        {{ formatFullName(row.item) }}
      </template>

      <template v-slot:cell(action)="row">
        <b-button
          size="sm"
          @click="deleteTrainer(row)"
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('training-view.deleteTrainer')"
        >
          <b-icon icon="trash"></b-icon>
        </b-button>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t("training-view.emptyTrainersTable") }}</h6>
      </template>
    </b-table>
  </div>
</template>

<script>
import trainingService from "../../services/training.service";
import {handleApiError} from "../../services/error.service";
import axios from "axios";

export default {
  props: {
    activity: {
      type: Object
    }
  },
  data() {
    return {
      availableTrainers: [],
      trainerToAdd: {
        associateName: null,
        position: 'TRAINER',
        member: null,
        type: null,
        partTime: null
      },
      trainerPositions: [
        { value: 'TRAINER', text: this.$t('trainingLeadersEnums.TRAINER') },
        { value: 'ASSOCIATE', text: this.$t('trainingLeadersEnums.ASSOCIATE') },
      ],
      trainerTypes: [
        { value: null, text: this.$t('training-view.selectType'), disabled: true },
        { value: 'INSTRUCTOR', text: this.$t('training-view.INSTRUCTOR') },
        { value: 'TRAIN_SUPPORT', text: this.$t('training-view.TRAIN_SUPPORT') },
        { value: 'BOTH', text: this.$t('training-view.BOTH') },
        
      ],
      trainerPartTimeTypes: [
        { value: null, text: this.$t('training-view.selectPartTime'), disabled: true},
        { value: false , text: this.$t('training-view.partTime.false') },
        { value: true , text: this.$t('training-view.partTime.true') },
      ],
      fields: [
        { key: "id", label: "Α.Μ.", sortable: false, thClass: 'text-left', tdClass: 'text-left'},
        { key: "fullName", label: "Ονοματεπώνυμο", sortable: false , sortByFormattted: true, thClass: 'text-left', tdClass: 'text-left'},
        { key: "position", label: "Καθήκοντα", sortable: false , formatter: "translatePosition", thClass: 'text-left', tdClass: 'text-left'}, 
        { key: "leaderType", label: "Ρόλος", sortable: false , formatter: "translateLeaderType", thClass: 'text-left', tdClass: 'text-left'}, 
        { key: "partTime", label: "Απασχόληση", sortable: false ,formatter: "translatePartTime", thClass: 'text-left', tdClass: 'text-left' },
        { key: "action", label: "Ενέργεια", sortable: false  }
      ],
      sortBy: "fullName",
      sortDesc: false,
      search: null,
      cancelSource: null,
    }
  },
  methods: {
    addTrainer() {
      trainingService.addLeader(this.activity.id, this.trainerToAdd).then(
        (response) => {
          this.$log.debug(response.data)
          this.trainerToAdd = response.data;
          this.trainerToAdd.leaderType = this.trainerToAdd.type;
          this.activity.leaders.push(this.trainerToAdd);
          this.$emit('leaders-changed', this.activity.leaders);
          this.trainerToAdd= {
            associateName: null,
            position: 'TRAINER',
            member: null,
            type: null,
            partTime: null
          }
        }, 
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
      
    },
    deleteTrainer(row) {
      trainingService.deleteLeader(this.activity.id, row.item.id).then(
        (response) => {
          this.$log.debug(response.data)
          for (let i = 0; i < this.activity.leaders.length; i++) {
            const leader = this.activity.leaders[i];
            if(leader.member.id == row.item.member.id) {
              this.activity.leaders.splice(i,1);
            }
          }
        }, 
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
      
    },
    resetTrainerName() {
      this.trainerToAdd.member = null;
      this.trainerToAdd.associateName = null;
    },
    formatId(leader) {
      return leader.position != 'ASSOCIATE' ? (leader.member.id) : '-';
    },
    formatFullName(leader) {
      return leader.position != 'ASSOCIATE' ? (leader.member.surName +" " + leader.member.firstName) : leader.associateName ;
    },
    translatePosition(position) {
      return this.$t('trainingLeadersEnums.'+ position);
    },
    translateLeaderType(type) {
      return this.$t('training-view.' + type);
    },
    translatePartTime(partTime) {
      return this.$t('training-view.partTime.'+ partTime);
    },
    cancelSearch () {
      if (this.cancelSource) {
        this.cancelSource.cancel('cancel');
      }
    },
    getActiveLeaders(search, loading) {
      if (search.length<1){
        return;
      }
      loading(true);
      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source()
      trainingService.getActiveLeaders(search).then(
        (response) => {
          let temp = [];
          response.data.forEach(trainer => {
            temp.push({label: trainer.surName + " " + trainer.firstName , member: trainer })
          })
          this.availableTrainers =  temp;

          loading(false);
          this.cancelSource=null;
        }, (error) => {
          loading(false);
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      );
    }
  }
}
</script>